import { Reveal, Chapter } from "@/components/Reveal";

const KEYWORDS = [
  "Luxury Hospitality",
  "Fine Dining",
  "Pre-Openings",
  "Hotel Operations",
  "Restaurant Leadership",
  "Beverage Strategy",
  "Guest Experience",
  "International Recruitment",
];

const Experience = () => (
  <section data-testid="experience-section" className="bg-sand py-28 lg:py-40">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Chapter number="06" label="Experience & Credibility" />
      </Reveal>
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <p
              data-testid="experience-years"
              className="font-serif font-light text-[7rem] lg:text-[11rem] leading-none text-ink"
            >
              15<span className="text-bronze">+</span>
            </p>
            <p className="text-[11px] tracking-[0.4em] uppercase text-ink/50 mt-2">
              Years of Operational Leadership
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:pt-10">
          <Reveal delay={0.15}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.1] text-ink">
              The Power of <span className="italic text-bronze">Operational Experience</span>
            </h2>
            <p className="mt-7 text-ink/70 font-light leading-relaxed max-w-2xl">
              Our experience spans hotel food and beverage operations, luxury restaurant concepts,
              international pre-openings, fine dining, lifestyle venues and premium hospitality
              environments.
            </p>
            <p className="mt-5 text-ink/70 font-light leading-relaxed max-w-2xl">
              This operational background allows BR Hospitality to evaluate candidates differently.
              We understand the realities of the operation because we have worked inside them.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10 flex flex-wrap gap-3">
              {KEYWORDS.map((k) => (
                <span
                  key={k}
                  data-testid={`experience-keyword-${k.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[10px] tracking-[0.2em] uppercase text-ink/60 border border-ink/20 px-4 py-2 hover:border-bronze hover:text-bronze transition-colors duration-500"
                >
                  {k}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Experience;
